import { makeStyles } from '@material-ui/core/styles'

const ICON_CIRCLE_BACKGROUND = '#EBF0F2'
const ICON_CIRCLE_COLOR = '#172024'

const useStyles = makeStyles(theme => ({
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    minWidth: 0,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    borderBottom: '1px solid #E0E0E0',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(1),
      padding: theme.spacing(2),
    },
  },
  cardTitleBlock: {
    minWidth: 0,
  },
  cardTitle: {
    color: '#172024',
    marginBottom: theme.spacing(0.25),
  },
  cardSubtitle: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.text.secondary,
  },
  cardAction: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  },
  metricList: {
    padding: 0,
  },
  metricRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(160px, 220px) minmax(0, 1fr) auto',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.02)',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
      alignItems: 'flex-start',
      gap: theme.spacing(1.5),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  metricLabelCell: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    minWidth: 0,
    paddingTop: theme.spacing(0.25),
  },
  metricLabelText: {
    minWidth: 0,
  },
  metricIconCircle: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: ICON_CIRCLE_BACKGROUND,
    color: ICON_CIRCLE_COLOR,
    '& .MuiSvgIcon-root': {
      fontSize: 14,
    },
  },
  metricLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: 1.3,
    color: '#172024',
  },
  metricVisual: {
    minWidth: 0,
  },
  metricStats: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1.5),
    flexWrap: 'nowrap',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      gap: theme.spacing(0.75, 1.5),
      width: '100%',
    },
  },
  metricValues: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'normal',
      flexShrink: 1,
      minWidth: 0,
    },
  },
}))

export default useStyles
